import { Input, Select, Switch } from "antd";
import React from "react";
import { FormOutlined } from "@ant-design/icons";
import DefaultSelect from "./DefaultSelect";

interface IOptionList {
	value: any;
	label: any;
}
interface IOrderDetailsRowParams {
	style?: React.CSSProperties;
	label: string;
	value?: any;
	editable?: boolean;
	bool?: boolean;
	select?: boolean;
	onChangeText?: (text: string) => void;
	type?: string;
	placeholder?: string;
	className?: any;
	onCheck?: (checked: boolean) => void;
	checked?: boolean;
	labelInValue?: boolean;
	allowClear?: boolean;
	options?: IOptionList[];
	onChange?: (value: any) => void;
	onClear?: () => void;
	status?: any;
	onBlur?: () => void;
	classNameLabel?: any;
	inputStyle?: React.CSSProperties;
	onSearch?: any;
}

const OrderDetailRow = ({
	style,
	label,
	value,
	editable,
	onChangeText,
	placeholder,
	className,
	bool,
	onCheck,
	checked,
	type,
	select,
	labelInValue,
	allowClear,
	options,
	onChange,
	onClear,
	status,
	onBlur,
	classNameLabel,
	inputStyle,
	onSearch,
}: IOrderDetailsRowParams) => {
	return (
		<div className="flex flex-row  items-center min-h-14 p-3" style={style}>
			<p style={styles.label} className={classNameLabel}>
				{label}:
			</p>
			{editable ? (
				<div style={styles.editableContainer}>
					{bool ? (
						<div style={styles.switch}>
							<Switch
								onChange={(checked) =>
									onCheck && onCheck(checked)
								}
								checked={checked}
								className="bg-[#DADEE7]"
							/>
						</div>
					) : select ? (
						<DefaultSelect
							labelInValue={labelInValue}
							allowClear={allowClear}
							placeholder={placeholder}
							options={options}
							onChange={onChange}
							value={value}
							className={className}
							onClear={onClear}
							status={status}
							style={{ ...styles.container, ...inputStyle }}
							onSearch={onSearch}
						/>
					) : (
						<Input
							placeholder={placeholder}
							value={value}
							className={className}
							style={{
								...styles.value,
								...styles.textInput,
								...styles.textContainer,
								...inputStyle,
							}}
							onChange={(e) =>
								onChangeText && onChangeText(e.target.value)
							}
							suffix={<FormOutlined />}
							type={type}
							onBlur={onBlur}
						/>
					)}
				</div>
			) : (
				<p style={styles.value}>{value}</p>
			)}
		</div>
	);
};

export default OrderDetailRow;

const styles = {
	container: {
		height: "40px",
		width: "8.8rem",
	},
	label: {
		fontSize: 14,
		fontWeight: "bold",
		color: "#2C2C2C",
		fontFamily: "Inter",
		width: "50%",
	},
	value: {
		width: "50%",
		fontFamily: "Inter",
		color: "#2C2C2C",
		fontSize: 14,
		fontWeight: 400,
		display: "flex",
		justifyContent: "flex-start",
	},
	editableContainer: {
		width: "50%",
		display: "flex",
		justifyContent: "flex-start",
	},
	textInput: {
		backgroundColor: "#fff",
		height: "40px",
		width: "10rem",
	},
	textContainer: {
		outline: "none",
		width: "9rem",
	},
	switch: {
		width: "50%",
		display: "flex",
		justifyContent: "flex-start",
	},
};
